import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Decharges from "./decharge/decharges";
import MateriauxInertes from "./pages/materiauxInertes";
import { Toaster } from 'react-hot-toast';
import DapForm from "./components/DapForm";

const HomeOne = lazy(() => import("./home/HomeOne"));
const HomeTwo = lazy(() => import("./home/HomeTwo"));
const HomeThree = lazy(() => import("./home/HomeThree"));
const About = lazy(() => import("./pages/About"));
const SablesCoquillagesNegoces = lazy(() => import("./sablescoquillagesnegoces/SablesCoquillagesNegoces"));
const Projects = lazy(() => import("./project/Projects"));
const ProjectDetails = lazy(() => import("./project/ProjectDetails"));
const BlogRightSidebar = lazy(() => import("./blog/BlogRightSidebar"));
const BlogDetailsLeftSidebar = lazy(() => import("./blog/BlogDetailsLeftSidebar"));
const BlogDetailsRightSidebar = lazy(() => import("./blog/BlogDetailsRightSidebar"));
const Contact = lazy(() => import("./pages/Contact"));
const NoMAtch = lazy(() => import("./pages/404"));

const App = () => {
  return (
    <>  
    <Toaster position="center" />
      <Router>
        <Suspense fallback={<div />}>
          <Routes>
            <Route path="/" element={<HomeThree />} />
            <Route path="/home-one" element={<HomeOne />} />
            <Route path="/home-two" element={<HomeTwo />} />
            <Route path="/home-three" element={<HomeThree />} />
            <Route path="/about-us" element={<About />} />
            <Route path="dap/form" element={<DapForm></DapForm>}></Route>
            <Route path="/sables-coquillages-negoces" element={<SablesCoquillagesNegoces />} />
            <Route path="/nos-sites" element={<Projects />} />
            <Route path="/recyclage-materiaux-inertes" element={<MateriauxInertes />} />
            <Route path="/site-loonplage-details" element={<ProjectDetails />} />
            <Route path="/mise-en-decharge-materiaux-inertes" element={<Decharges />} />
            <Route path="/blog-right-sidebar" element={<BlogRightSidebar />} />
            <Route path="/blog-details-left-sidebar" element={<BlogDetailsLeftSidebar />} />
            <Route path="/blog-details-right-sidebar" element={<BlogDetailsRightSidebar />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="*" element={<NoMAtch />} />
          </Routes>
        </Suspense>
      </Router>
    </>

  )
}

export default App